import React, { useEffect, useState } from "react";
import { Icons, iconColors } from "./icons";
import {
  Bell,
  Bot,
  QrCode
} from "lucide-react";
import MenuEditorOverlay from "./MenuEditorOverlay";
import './DashboardCameriereMenu.css';
import { Link, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Logo from "./components/Logo";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "./firebase";
import { useRuolo } from "./useRuolo";
import {
  collection,
  getDocs,
  deleteDoc,
  doc,
  getDoc,
  onSnapshot,
  setDoc,
  addDoc,
  serverTimestamp
} from "firebase/firestore";
import { QRCodeCanvas } from "qrcode.react";
import "./Dashboard.css";
import "./navbar-spacing.css";
import {
  generaAlertAISala
} from "./ai/aiSalaEngine";

function DashboardGestore() {
  const [user] = useAuthState(auth);
  const { ruolo, loading } = useRuolo(user?.uid);
  const navigate = useNavigate();
  const [stats, setStats] = useState({ locali: 0, utenti: 0, ordini: 0 });
  const [attivazioni, setAttivazioni] = useState([]);
  const [messaggio, setMessaggio] = useState("");
  const [incassoOggi, setIncassoOggi] = useState(0);
  const [infoLocale, setInfoLocale] = useState({});
  const [mieiLocali, setMieiLocali] = useState([]);
  const [tavoliVisibili, setTavoliVisibili] = useState([]);
  const [aiRefreshTick, setAiRefreshTick] = useState(0);
  
  const [tavoloSelezionato, setTavoloSelezionato] = useState(null); // Per modale azioni tavolo
  const [alertAISelezionato, setAlertAISelezionato] = useState(null);
const [alertAIGestiti, setAlertAIGestiti] = useState([]);

const getLocaleAlertGestore = () => mieiLocali?.[0] || null;

const normalizzaAlertTipo = (alert) => {
  const testo = String(alert?.testo || alert?.text || "").toLowerCase();

  if (alert?.tipo) return alert.tipo;
  if (alert?.type) return alert.type;

  if (testo.includes("inattivo")) return "tavoloInattivo";
  if (testo.includes("servito")) return "tavoloServitoDa";

  return "generico";
};

const getAlertAIKey = (tavolo, alert) => {
  const locale = getLocaleAlertGestore();
  const tipo = normalizzaAlertTipo(alert);

const sessione =
  tavolo?.token ||
  tavolo?.tokenSessione ||
  tavolo?.tokenAttuale ||
  tavolo?.sessionId ||
  tavolo?.clienteId ||
  tavolo?.creatoIl?.seconds ||
  "sessione";

  return `${locale}_${tavolo?.numero}_${tipo}_${sessione}`;
};

const filtraAlertAIGestiti = (tavolo, alerts = []) =>
  alerts.filter(alert => !alertAIGestiti.includes(getAlertAIKey(tavolo, alert)));

const segnaAlertGestito = async (tavolo) => {
  try {
    const locale = getLocaleAlertGestore();
    if (!locale || !tavolo?.numero) return;

    await Promise.all(
      (tavolo.alertAI || []).map((alert) => {
        const key = getAlertAIKey(tavolo, alert);

        return setDoc(
          doc(db, "ai_alert_gestiti", key),
          {
            key,
            locale,
            tavolo: String(tavolo.numero),
            tipo: normalizzaAlertTipo(alert),
            testo: alert?.testo || alert?.text || "",
            gestito: true,
            gestitoAt: serverTimestamp()
          },
          { merge: true }
        );
      })
    );

    setAlertAISelezionato(null);
  } catch (err) {
    console.error("Errore salvataggio alert gestito:", err);
  }
};

useEffect(() => {
  const locale = getLocaleAlertGestore();
  if (!locale) return;

  const unsub = onSnapshot(collection(db, "ai_alert_gestiti"), (snap) => {
    const keys = snap.docs
      .map(d => d.data())
      .filter(a => a.locale === locale && a.gestito === true)
      .map(a => a.key);

    setAlertAIGestiti(prev => {
  const prevString = [...prev].sort().join("|");
  const nextString = [...keys].sort().join("|");

  if (prevString === nextString) {
    return prev;
  }

  return keys;
});
  });

  return () => unsub();
}, [mieiLocali]);

  const [chiamateServizio, setChiamateServizio] = useState([]); // Tavoli che hanno chiamato il servizio
  const [dataLoading, setDataLoading] = useState(true); // Stato caricamento dati
    const [localeBloccato, setLocaleBloccato] = useState(false);
  const [showDemoPopup, setShowDemoPopup] = useState(false);
  useEffect(() => {

  const interval = setInterval(() => {

    setAiRefreshTick(prev => prev + 1);

  }, 30000);

  return () => clearInterval(interval);

}, []);
const [giorniResiduiDemo, setGiorniResiduiDemo] = useState(null);


  const [creditoOpenAI, setCreditoOpenAI] = useState(null);
  const [caricamentoCredito, setCaricamentoCredito] = useState(false);
  const [showQrCucina, setShowQrCucina] = useState(false);

const [showAsportoMenu, setShowAsportoMenu] = useState(false);
const [showResetAsportoModal, setShowResetAsportoModal] = useState(false);
const [resetAsportoLoading, setResetAsportoLoading] = useState(false);

const [showAISalaConfig, setShowAISalaConfig] = useState(false);
const [showAsportoSlotsConfig, setShowAsportoSlotsConfig] = useState(false);
const [categorieAsportoSlot, setCategorieAsportoSlot] = useState([]);
const asportoSlotsConfig = infoLocale?.asportoSlots || {
  enabled: false,
  oraInizio: "19:30",
  oraFine: "23:00",
  intervalloMinuti: 15,
  maxPezziPerSlot: 10,
categorieConteggiate: []
};

const salvaAsportoSlotsConfig = async (nuovaConfig) => {
  try {
    await setDoc(
      doc(db, "locali", mieiLocali[0]),
      {
        asportoSlots: nuovaConfig
      },
      { merge: true }
    );
  } catch (err) {
    console.error("Errore salvataggio slot asporto:", err);
    alert("Errore salvataggio slot asporto");
  }
};
useEffect(() => {
  const caricaCategorieAsportoSlot = async () => {
    if (!mieiLocali[0]) return;

    try {
      const snap = await getDocs(collection(db, "categorie"));

      const lista = snap.docs
        .map((d) => ({ id: d.id, ...d.data() }))
        .filter(
          (c) =>
            c.localeTag === mieiLocali[0] &&
            c.visibile !== false
        )
        .sort((a, b) => (a.ordine || 0) - (b.ordine || 0));

      setCategorieAsportoSlot(lista);
    } catch (err) {
      console.error("Errore caricamento categorie slot asporto:", err);
    }
  };

  caricaCategorieAsportoSlot();
}, [mieiLocali]);
const [aiSalaConfig, setAiSalaConfig] = useState({
  enabled: true,

  supervisoreSala: {
    tavoloInattivo: {
      enabled: true,
      minuti: 15
    },

    tavoloServitoDa: {
      enabled: true,
      minuti: 20
    }
  }
});

  const [showDemoTablesPopup, setShowDemoTablesPopup] = useState(false);
const tutorialKey = `hideDemoTutorial_${mieiLocali[0] || "default"}`;

const [hideDemoTutorial, setHideDemoTutorial] = useState(false);
useEffect(() => {
  if (!mieiLocali[0]) return;

  const tutorialKey =
    `hideDemoTutorial_${mieiLocali[0]}`;

  setHideDemoTutorial(
    localStorage.getItem(tutorialKey) === "true"
  );
}, [mieiLocali]);

  const onboardingSteps = [
  !!infoLocale?.menuCreato,
  !!infoLocale?.haUsatoAI,
  !!infoLocale?.haConfiguratoAI,
  !!infoLocale?.haProvatoMenu,
  !!infoLocale?.haProvatoDashboardCameriere,
  !!infoLocale?.haProvatoDashboardCucina
];

const onboardingCompleted =
  onboardingSteps.filter(Boolean).length;

const onboardingPercent =
  Math.round(
    (onboardingCompleted / onboardingSteps.length) * 100
  );

  
useEffect(() => {
  if (onboardingPercent >= 100) {
    localStorage.setItem(tutorialKey, "true");
    setHideDemoTutorial(true);
  }
}, [onboardingPercent]);


  // Overlay stato
  const [menuOverlayOpen, setMenuOverlayOpen] = useState(false);
  const [tavoloPerNuovoOrdine, setTavoloPerNuovoOrdine] = useState(null);

  const adminItems = [
    {
      text: "Crea nuovo locale",
      path: "/adminlocali",
      color: "#4CAF50",
      icon: <Icons.settings style={{ color: iconColors.success }} />
    },
    {
      text: "Visualizza locali",
      path: "/visualizzalocali",
      color: "#2196F3",
      icon: <Icons.ordini style={{ color: iconColors.primary }} />
    },
    {
      text: "Genera QR",
      path: "/qr-generator",
      color: "#FF9800",
      icon: <Icons.qr style={{ color: iconColors.warning }} />
    },
    {
      text: "Gestione Utenti",
      path: "/gestione-utenti",
      color: "#607D8B",
      icon: <Icons.training style={{ color: iconColors.neutral }} />
    }
  ];

const gestoreItems = [
  {
    text: "Controllo ordini",
    path: "/ordersdashboard",
    color: "#E91E63",
    flagKey: "nascondiOrdini",
    icon: <Icons.ordini style={{ color: iconColors.warning }} />
  },
  {
    text: "Flusso cucina",
    path: "/dashboard-cucina",
    color: "#795548",
    flagKey: "nascondiCucina",
    icon: <Icons.cucina style={{ color: iconColors.primary }} />
  },
  {
    text: "Incassi e pagamenti",
    path: "/dashboard-cassa",
    color: "#009688",
    flagKey: "nascondiCassa",
    icon: <Icons.cassa style={{ color: iconColors.success }} />
  }
];

  const itemsToShow = ruolo === "admin"
    ? [...adminItems, ...gestoreItems]
    : ruolo === "gestore"
    ? gestoreItems.filter(item => !item.flagKey || !infoLocale[item.flagKey])
    : [];

useEffect(() => {
    const fetchStats = async () => {
      if (ruolo === "admin") {
        try {
          const localiSnap = await getDocs(collection(db, "locali"));
          const utentiSnap = await getDocs(collection(db, "utenti"));
          const ordiniSnap = await getDocs(collection(db, "ordini"));

          const oggi = new Date();
          oggi.setHours(0, 0, 0, 0);
          const incasso = ordiniSnap.docs
            .map((doc) => doc.data())
            .filter((o) => o.stato === "pagato" && o.timestamp?.seconds)
            .filter((o) => {
              const dataOrdine = new Date(o.timestamp.seconds * 1000);
              return dataOrdine >= oggi;
            })
            .reduce((sum, o) => sum + (o.totale || 0), 0);

          setStats({
            locali: localiSnap.size,
            utenti: utentiSnap.size,
            ordini: ordiniSnap.size
          });
          setIncassoOggi(incasso);
        } catch (err) {
          console.error("❌ Errore nel fetchStats:", err);
        }
      }
    };
    fetchStats();
  }, [ruolo]);

  useEffect(() => {

    if (!user || !ruolo || (ruolo !== "gestore" && ruolo !== "admin")) return;

    // 📊 TRACKING ACCESSO GESTORE (1 volta ogni 24h)
const trackGestoreAccess = async () => {

  try {


    const searchParams =
      new URLSearchParams(window.location.search);

    const forcedLocale =
      searchParams.get("locale");


    let localeTag = forcedLocale || null;

    localeTag =
      String(localeTag || "")
        .trim()
        .toLowerCase();

    // fallback locale normale
    if (!localeTag) {

      const utenteRef =
        doc(db, "utenti", user.uid);

      const utenteSnap =
        await getDoc(utenteRef);

      if (utenteSnap.exists()) {

        const datiUtente =
          utenteSnap.data();


        localeTag =
          datiUtente.localeTag ||
          (Array.isArray(datiUtente.locali)
            ? datiUtente.locali[0]
            : null);

        localeTag =
          String(localeTag || "")
            .trim()
            .toLowerCase();

      }

    }

    const accessKey =
      `lastDashboardAccess_${user.uid}_${localeTag}`;
    const lastAccess =
      localStorage.getItem(accessKey);

    const now = Date.now();

    // 24 ore
    const DAY_MS =
      24 * 60 * 60 * 1000;

    if (
      lastAccess &&
      now - Number(lastAccess) < DAY_MS
    ) {
      return;
    }

    await addDoc(
      collection(db, "analytics_gestore"),
      {
        uid: user.uid,
        email: user.email || null,
        ruolo,
        localeTag: localeTag || null,
        timestamp: serverTimestamp(),
        demo:
  localeTag?.startsWith("demo")
      }
    );

    localStorage.setItem(
      accessKey,
      now.toString()
    );

    console.log(
      "📊 Accesso gestore registrato"
    );

  } catch (err) {

    console.error(
      "❌ Errore tracking accesso gestore:",
      err
    );

  }

};

trackGestoreAccess();

    
    let unsubscribeOrdini = null;
    let unsubscribeAttivazioni = null;
    let unsubscribeInfoLocale = null; // listener realtime per infoLocale
    let unsubscribeChiamate = null;

    const setupRealtimeListeners = async () => {
      try {
        // Carica dati utente e locale
        const searchParams = new URLSearchParams(window.location.search);
const forcedLocale = searchParams.get("locale");
console.log("🧪 forcedLocale =", forcedLocale);

        let locali = [];

        if (forcedLocale) {

          console.log("🧪 Modalità demo/admin:", forcedLocale);

          locali = [forcedLocale];

        } else {

          const utentiSnap = await getDocs(collection(db, "utenti"));
          const mioUtente = utentiSnap.docs.find(doc => doc.id === user.uid);

         locali =
  mioUtente?.data()?.locali ||
  (mioUtente?.data()?.localeTag
    ? [mioUtente.data().localeTag]
    : []);

        }
          

        console.log("🏪 Miei locali configurati:", locali);
        setMieiLocali(locali);

          if (!locali.length || !locali[0]) {
            console.error(
              "❌ Nessun locale valido trovato"
            );
            return;
          }

          // 🔥 MODALITÀ DEMO / FORCED LOCALE
if (forcedLocale) {

  const forcedRef = doc(db, "locali", forcedLocale);

  const forcedSnap = await getDoc(forcedRef);

  if (forcedSnap.exists()) {

    const forcedData = forcedSnap.data();

    setInfoLocale(forcedData);

  }

}

        const ref = doc(db, "locali", locali[0]);
        // Sottoscrizione realtime al documento del locale per aggiornare subito i flag UI
        unsubscribeInfoLocale = onSnapshot(ref, (snapRealtime) => {
            if (!snapRealtime.exists()) return;

            const data = snapRealtime.data();


            setInfoLocale(data);
if (data.aiSalaConfig) {
  setAiSalaConfig(data.aiSalaConfig);
}
            // 🎭 DEMO COUNTDOWN
            if (
              data.demo === true &&
              data.trialEnd
            ) {

              const now = Date.now();

              const end =
                data.trialEnd.toDate().getTime();

              const diff =
                end - now;

              const giorni =
                Math.max(
                  0,
                  Math.ceil(
                    diff / (1000 * 60 * 60 * 24)
                  )
                );

              setGiorniResiduiDemo(giorni);

              // popup ad ogni refresh/apertura
              setTimeout(() => {
                setShowDemoPopup(true);
              }, 700);

            }

            // 🔥 BLOCCO REALTIME
            if (
  data.stato === "bloccato" ||
  data.trialExpired === true
) {

  setLocaleBloccato(true);

} else {

  setLocaleBloccato(false);

}
        });

        const snap = await getDoc(ref);
        if (!snap.exists()) {
          console.warn("⚠️ Documento locale non esiste:", locali[0]);
          return;
        }

        const datiLocale = snap.data();

        // NON sovrascrivere il realtime
        setInfoLocale(prev => ({
          ...prev,
          ...datiLocale
        }));
        const numeroTavoli = datiLocale?.numeroTavoli || datiLocale?.tavoli || 0;
        const sale = datiLocale?.sale || [];
        
        if (numeroTavoli === 0 && sale.length === 0) {
          setInfoLocale(datiLocale);
          setDataLoading(false);
          setTavoliVisibili([]);
          return;
        }

        // Funzione per aggiornare i tavoli
        const aggiornaTavoli = (attivazioniData, ordiniData) => {
          const ATTIVAZIONE_TIMEOUT_MINUTI = 120;
          const tavoli = [];
          // Tavoli principali
          for (let i = 0; i < numeroTavoli; i++) {
            const numeroTavolo = (i + 1).toString();
            const id = `${locali[0]}_${numeroTavolo}`;
            const attivoRaw =
  attivazioniData.find((a) => {

    const parts = a.id.split("_");

    const localeDoc = parts[0];
    const tavoloDoc = parts[1];

    return (
      localeDoc === locali[0] &&
      String(tavoloDoc).toUpperCase() ===
      String(numeroTavolo).toUpperCase()
    );

  });

const ultimoPing =
  attivoRaw?.ultimoPing?.seconds
    ? attivoRaw.ultimoPing.seconds * 1000
    : null;

const attivoRecente =
  ultimoPing &&
  (
    Date.now() - ultimoPing
  ) <
  (
    ATTIVAZIONE_TIMEOUT_MINUTI *
    60 *
    1000
  );

const attivo =
  attivoRecente
    ? attivoRaw
    : null;
            // Cerca ordini attivi per questo tavolo
            const ordiniTavolo = ordiniData.filter(o => 
              String(o.table) === String(numeroTavolo) && locali.includes(o.locale)
            );
            const haOrdiniAttivi = ordiniTavolo.length > 0;
            const totaleOrdini = ordiniTavolo.reduce((sum, o) => sum + (o.totale || 0), 0);
  
const clientePresente =
  !!attivo && !haOrdiniAttivi;

tavoli.push({
  id,
  numero: numeroTavolo,
  sala: "principale",

  attivo: !!attivo,

  clientePresente,

  impegnato: haOrdiniAttivi,
  ordiniAttivi: ordiniTavolo.length,
  totaleOrdini: totaleOrdini,

  
alertAI:
  filtraAlertAIGestiti(
    {
      numero: numeroTavolo,
      ...attivo
    },
    generaAlertAISala({

    tavolo: {
      numero: numeroTavolo,
      impegnato: haOrdiniAttivi,
      attivo: !!attivo,
      ...attivo
    },

    aiSalaConfig,

    ordini: ordiniTavolo,

    chiamateServizio

    })
),

  ...attivo
});
          }
          
          // Tavoli delle sale aggiuntive
          sale.forEach(sala => {
            for (let i = 1; i <= sala.numeroTavoli; i++) {
              const numeroTavolo = `${sala.lettera}${i}`;
              const id = `${locali[0]}_${numeroTavolo}`;
              const attivoRaw =
  attivazioniData.find((a) => {

    const parts = a.id.split("_");

    const localeDoc = parts[0];
    const tavoloDoc = parts[1];

    return (
      localeDoc === locali[0] &&
      String(tavoloDoc).toUpperCase() ===
      String(numeroTavolo).toUpperCase()
    );

  });

const ultimoPing =
  attivoRaw?.ultimoPing?.seconds
    ? attivoRaw.ultimoPing.seconds * 1000
    : null;

const attivoRecente =
  ultimoPing &&
  (
    Date.now() - ultimoPing
  ) <
  (
    ATTIVAZIONE_TIMEOUT_MINUTI *
    60 *
    1000
  );

const attivo =
  attivoRecente
    ? attivoRaw
    : null;
              
              const ordiniTavolo = ordiniData.filter(o => 
                String(o.table).toUpperCase() === String(numeroTavolo).toUpperCase() && locali.includes(o.locale)
              );
              
              // Debug per Sala A
              if (sala.lettera === 'A' && ordiniTavolo.length > 0) {
                console.log(`✅ Tavolo ${numeroTavolo} ha ${ordiniTavolo.length} ordini`, ordiniTavolo.map(o => o.table));
              }
              
              // Debug per capire perché non trova ordini
              if (sala.lettera === 'A' && i === 1) {
                const tuttiOrdiniSalaA = ordiniData.filter(o => 
                  String(o.table).toUpperCase().startsWith('A') || String(o.tavolo).toUpperCase().startsWith('A')
                );
                console.log(`🔍 Gestore Debug A1 - numeroTavolo: "${numeroTavolo}"`);
                tuttiOrdiniSalaA.forEach(o => {
                  console.log(`  - Ordine: table="${o.table}", tavolo="${o.tavolo}", match=${String(o.table).toUpperCase() === String(numeroTavolo).toUpperCase()}`);
                });
              }
              
              const haOrdiniAttivi = ordiniTavolo.length > 0;
              const totaleOrdini = ordiniTavolo.reduce((sum, o) => sum + (o.totale || 0), 0);
            
const clientePresente =
  !!attivo && !haOrdiniAttivi;

tavoli.push({
  id,
  numero: numeroTavolo,
  sala: sala.lettera,

  attivo: !!attivo,

  clientePresente,

  impegnato: haOrdiniAttivi,
  ordiniAttivi: ordiniTavolo.length,
  totaleOrdini: totaleOrdini,

  

alertAI:
  filtraAlertAIGestiti(
    {
      numero: numeroTavolo,
      ...attivo
    },
    generaAlertAISala({

    tavolo: {
      numero: numeroTavolo,
      impegnato: haOrdiniAttivi,
      attivo: !!attivo,
      ...attivo
    },

    aiSalaConfig,

    ordini: ordiniTavolo,

    chiamateServizio

    })
),

  ...attivo
});
            }
          });
          
          setTavoliVisibili(tavoli);
          setDataLoading(false);
        };

        // Listener real-time per attivazioni
        unsubscribeAttivazioni = onSnapshot(
  collection(db, "attivazioniSessioni"), 
          (snapshot) => {
            const attivazioniData = snapshot.docs
              .map(doc => ({ id: doc.id, ...doc.data() }))
              .filter(a => locali.includes(a.id.split("_")[0]));
            
            setAttivazioni(attivazioniData);

            // Ricarica anche gli ordini per aggiornare i tavoli
            getDocs(collection(db, "ordini")).then(ordiniSnap => {
              const ordiniAttivi = ordiniSnap.docs
                .map(doc => ({ id: doc.id, ...doc.data() }))
                .filter(o => o.stato !== "pagamento" && o.stato !== "archiviato" && locali.includes(o.locale));
              
              aggiornaTavoli(attivazioniData, ordiniAttivi);
            });
          },
          (error) => {
            console.error("❌ Errore listener attivazioni:", error);
          }
        );
        // Listener real-time per ordini (pulito)
        unsubscribeOrdini = onSnapshot(
          collection(db, "ordini"),
          (snapshot) => {
            const ordiniAttivi = snapshot.docs
              .map(doc => ({ id: doc.id, ...doc.data() }))
              .filter(o =>
                o.stato !== "pagamento" &&
                o.stato !== "archiviato" &&
                locali.includes(o.locale)
              );

            getDocs(collection(db, "attivazioniSessioni")).then(attivazioniSnap => {
              const attivazioniData = attivazioniSnap.docs
                .map(doc => ({ id: doc.id, ...doc.data() }))
                .filter(a => locali.includes(a.id.split("_")[0]));

              aggiornaTavoli(attivazioniData, ordiniAttivi);
            });
          },
          (error) => {
            console.error("❌ Errore listener ordini:", error);
          }
        );

        // Listener real-time per chiamate servizio (SEPARATO)
        unsubscribeChiamate = onSnapshot(
          collection(db, "chiamateServizio"),
          (snapshot) => {
            const chiamate = snapshot.docs
              .map(doc => ({ id: doc.id, ...doc.data() }))
              .filter(c => locali.includes(c.locale));

setChiamateServizio(chiamate);

          },
          (error) => {
            console.error("❌ Errore listener chiamate servizio:", error);
          }
        );

      } catch (err) {
        console.error("❌ Errore nel setup listeners:", err);
        setMessaggio("❌ Errore nel caricamento tavoli");
      }
    };

    setupRealtimeListeners();

    // Cleanup listeners quando il componente si smonta
    return () => {
      if (unsubscribeOrdini) unsubscribeOrdini();
      if (unsubscribeAttivazioni) unsubscribeAttivazioni();
      if (unsubscribeInfoLocale) unsubscribeInfoLocale();
      if (unsubscribeChiamate) unsubscribeChiamate();
    };
}, [user, ruolo, aiRefreshTick, alertAIGestiti]);

  // --- Gestione click su tavolo chiamato ---
  // Usa direttamente l'ID documento da Firestore (funziona con addDoc e setDoc)
  const gestisciChiamataServizio = async (chiamataId) => {
    try {
      console.log("🗑️ Eliminazione chiamata con ID:", chiamataId);
      await deleteDoc(doc(db, "chiamateServizio", chiamataId));
      console.log("✅ Chiamata servizio eliminata");
    } catch (error) {
      console.error("❌ Errore gestione chiamata:", error);
    }
  };

  const resetta = async (id) => {
    try {
      console.log("🔍 Tentativo di reset per ID:", id);
      
      // Verifica se il documento esiste prima di cancellarlo
      const docRef = doc(db, "attivazioniSessioni", id);
      const docSnap = await getDoc(docRef);
      
      if (!docSnap.exists()) {
        console.warn("⚠️ Documento attivazione non trovato:", id);
        setMessaggio(`⚠️ Tavolo ${id.split("_")[1]} non ha attivazione da resettare`);
          setTimeout(() => setMessaggio("") , 3000);
        return;
      }
      
      console.log("✅ Documento trovato, cancellazione in corso...");
      await deleteDoc(docRef);
      setMessaggio(`✅ Tavolo ${id.split("_")[1]} resettato`);
      setTimeout(() => setMessaggio(""), 3000);

     const snapshot = await getDocs(collection(db, "attivazioniSessioni"));
      const tutte = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));

      const filtrate = tutte.filter((a) => {
        const idLocale = a.id.split("_")[0];
        return mieiLocali.includes(idLocale);
      });

      setAttivazioni(filtrate);

      // Ricarica anche gli ordini attivi
      const ordiniSnap = await getDocs(collection(db, "ordini"));
      const ordiniAttivi = ordiniSnap.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .filter(o => o.stato !== "pagamento" && o.stato !== "archiviato");

      const numeroTavoli = infoLocale?.numeroTavoli || infoLocale?.tavoli || 0;
      const sale = infoLocale?.sale || [];
      const tavoli = [];
      
      // Tavoli principali
      for (let i = 0; i < numeroTavoli; i++) {
        const numeroTavolo = (i + 1).toString();
        const id = `${mieiLocali[0]}_${numeroTavolo}`;
        const attivo = filtrate.find((a) => a.id === id);
console.log(
  "🧪 ATTIVO PRINCIPALE FULL",
  JSON.stringify(attivo, null, 2)
);
        // Cerca ordini attivi per questo tavolo
        const ordiniTavolo = ordiniAttivi.filter(o => 
          String(o.table) === String(numeroTavolo) && mieiLocali.includes(o.locale)
        );
        
        const haOrdiniAttivi = ordiniTavolo.length > 0;
        const totaleOrdini = ordiniTavolo.reduce((sum, o) => sum + (o.totale || 0), 0);
        
const clientePresente =
  !!attivo && !haOrdiniAttivi;

tavoli.push({
  id,
  numero: numeroTavolo,
  sala: "principale",

  attivo: !!attivo,

  clientePresente,

  impegnato: haOrdiniAttivi,
          ordiniAttivi: ordiniTavolo.length,
          totaleOrdini: totaleOrdini,
          ...attivo
        });
      }
      
      // Tavoli delle sale aggiuntive
      sale.forEach(sala => {
        for (let i = 1; i <= sala.numeroTavoli; i++) {
          const numeroTavolo = `${sala.lettera}${i}`;
          const id = `${mieiLocali[0]}_${numeroTavolo}`;
          const attivo = filtrate.find((a) => a.id === id);
          
          const ordiniTavolo = ordiniAttivi.filter(o => 
            String(o.table) === String(numeroTavolo) && mieiLocali.includes(o.locale)
          );
          
          const haOrdiniAttivi = ordiniTavolo.length > 0;
          const totaleOrdini = ordiniTavolo.reduce((sum, o) => sum + (o.totale || 0), 0);
          
const clientePresente =
  !!attivo && !haOrdiniAttivi;

tavoli.push({
  id,
  numero: numeroTavolo,
  sala: sala.lettera,

  attivo: !!attivo,

  clientePresente,

  impegnato: haOrdiniAttivi,
            ordiniAttivi: ordiniTavolo.length,
            totaleOrdini: totaleOrdini,
            ...attivo
          });
        }
      });
      
      setTavoliVisibili(tavoli);
    } catch (err) {
      console.error("❌ Errore nel reset:", err);
      console.error("❌ Codice errore:", err.code);
      console.error("❌ Messaggio errore:", err.message);
      
      if (err.code === 'permission-denied') {
        setMessaggio("❌ Permessi insufficienti per resettare il tavolo");
      } else {
        setMessaggio(`❌ Errore nel reset: ${err.message}`);
      }
      setTimeout(() => setMessaggio(""), 5000);
    }
  };

// Reset contatore ordini asporto

const resetContatoreAsporto = async () => {
  if (!mieiLocali || mieiLocali.length === 0) {
    setShowResetAsportoModal(false);
    setMessaggio("❌ Nessun locale associato");
    setTimeout(() => setMessaggio(""), 3000);
    return;
  }

  try {
    setResetAsportoLoading(true);

    const contatoreRef = doc(
      db,
      "contatori_ordini_asporto",
      mieiLocali[0]
    );

    await setDoc(
      contatoreRef,
      { ultimoNumero: 0 },
      { merge: true }
    );

    setShowResetAsportoModal(false);
    setMessaggio("✅ Contatore ordini asporto azzerato");
    setTimeout(() => setMessaggio(""), 3000);
  } catch (error) {
    console.error("Errore reset contatore:", error);

    setShowResetAsportoModal(false);
    setMessaggio("❌ Errore durante il reset del contatore");
    setTimeout(() => setMessaggio(""), 3000);
  } finally {
    setResetAsportoLoading(false);
  }
};

useEffect(() => {
  const handleResetAsporto = () => {
    setShowResetAsportoModal(true);
  };

  window.addEventListener("resetAsporto", handleResetAsporto);

  return () => {
    window.removeEventListener("resetAsporto", handleResetAsporto);
  };
}, []);

  // Pulsante Inizializza Tavoli
  function InizializzaTavoli({ infoLocale, localeTag }) {
    const [loading, setLoading] = useState(false);
    const handleInit = async () => {
      setLoading(true);
      try {
        const numeroTavoli = infoLocale?.numeroTavoli || infoLocale?.tavoli || 0;
        const sale = infoLocale?.sale || [];
        // Tavoli principali
        for (let i = 0; i < numeroTavoli; i++) {
          const numeroTavolo = (i + 1).toString();
          const tavoloRef = doc(db, "tavoli", `${localeTag}_${numeroTavolo}`);
          await setDoc(tavoloRef, {
            sessioneAttiva: false,
            tokenSessione: null
          }, { merge: true });
        }
        // Tavoli delle sale aggiuntive
        for (const sala of sale) {
          const promesse = [];
          for (let i = 1; i <= sala.numeroTavoli; i++) {
            const numeroTavolo = `${sala.lettera}${i}`;
            const tavoloRef = doc(db, "tavoli", `${localeTag}_${numeroTavolo}`);
            promesse.push(
              setDoc(tavoloRef, { sessioneAttiva: false, tokenSessione: null }, { merge: true })
            );
          }
          await Promise.all(promesse);
        }
        alert("Tavoli inizializzati!");
      } catch (err) {
        alert("Errore inizializzazione tavoli: " + err.message);
      }
      setLoading(false);
    };
    return (
      <button
        style={{
          backgroundColor: "#43A047",
          color: "white",
          fontWeight: "bold",
          fontSize: "1rem",
          padding: "0.8rem 1.6rem",
          borderRadius: "8px",
          border: "none",
          margin: "1.2rem 0",
          cursor: loading ? "not-allowed" : "pointer",
          opacity: loading ? 0.7 : 1
        }}
        disabled={loading}
        onClick={handleInit}
      >
        🟩 Inizializza Tavoli
      </button>
    );
  }

  const caricaCreditoOpenAI = async () => {
    try {
      setCaricamentoCredito(true);
      const res = await fetch("/api/openai-credit");
      const data = await res.json();
      setCreditoOpenAI(data.credit);
    } catch (err) {
      console.error("❌ Errore nel recupero credito:", err);
      setCreditoOpenAI("Errore");
    } finally {
      setCaricamentoCredito(false);
    }
  };

  const salvaAISalaConfig = async (nuovaConfig) => {

  try {

    setAiSalaConfig(nuovaConfig);

    await setDoc(
      doc(db, "locali", mieiLocali[0]),
      {
        aiSalaConfig: nuovaConfig
      },
      { merge: true }
    );

  } catch (err) {

    console.error(
      "Errore salvataggio AI Sala:",
      err
    );

  }

};

const apriTavoloGestore = (tavolo) => {
  if (!tavolo) return;

  if (!tavolo.impegnato) {
    setTavoloPerNuovoOrdine(tavolo.numero);
    setMenuOverlayOpen(true);
  } else {
    setTavoloSelezionato(tavolo);
  }
};

  if (loading || ruolo === null || dataLoading) {
    return (
        <>
          {localeBloccato && (
            <div style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "#0f0f12",
              color: "#fff",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 999999,
              textAlign: "center"
            }}>
              {infoLocale?.trialExpired ? (
                <>
                  <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>🎭</div>
                  <h2>Demo scaduta</h2>
                  <p style={{ color: "#aaa", maxWidth: "420px" }}>
                    La tua prova gratuita di QrMenu è terminata.
                  </p>
                  <button
                    onClick={() => window.location.href = "/contatti"}
                    style={{
                      marginTop: "1.5rem",
                      background: "#ff9800",
                      border: "none",
                      color: "#fff",
                      padding: "0.9rem 1.4rem",
                      borderRadius: "12px",
                      fontWeight: "600",
                      cursor: "pointer"
                    }}
                  >
                    🚀 Attiva QrMenu
                  </button>
                </>
              ) : (
                <>
                  <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>🚫</div>
                  <h2>Locale disattivato</h2>
                  <p style={{ color: "#aaa" }}>
                    Contatta l'amministratore
                  </p>
                </>
              )}
            </div>
          )}
        <Navbar />
        <div className="container" style={{ textAlign: "center" }}>
          <p style={{ color: "#999" }}>🔄 Caricamento dashboard...</p>
        </div>
      </>
    );
  }

  return (
    <>
      <Navbar />
      {localeBloccato && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "#0f0f12",
          color: "#fff",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 999999,
          textAlign: "center"
        }}>
          {infoLocale?.trialExpired ? (
            <>
              <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>🎭</div>
              <h2>Demo scaduta</h2>
              <p style={{ color: "#aaa", maxWidth: "420px" }}>
                La tua prova gratuita di QrMenu è terminata.
              </p>
              <button
                onClick={() => window.location.href = "/contatti"}
                style={{
                  marginTop: "1.5rem",
                  background: "#ff9800",
                  border: "none",
                  color: "#fff",
                  padding: "0.9rem 1.4rem",
                  borderRadius: "12px",
                  fontWeight: "600",
                  cursor: "pointer"
                }}
              >
                🚀 Attiva QrMenu
              </button>
            </>
          ) : (
            <>
              <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>🚫</div>
              <h2>Locale disattivato</h2>
              <p style={{ color: "#aaa" }}>
                Contatta l'amministratore
              </p>
            </>
          )}
        </div>
      )}
      <div 
        className="container page-with-navbar responsive-gestore-container" 
        style={{ 
          backgroundColor: "#000000",
          color: "#ffffff",
          minHeight: "100vh"
        }}
      >
        {/* ...tutto il contenuto dashboard... */}
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "2rem", flexWrap: "wrap", marginBottom: "1rem" }}>
          <div
            className="logo-container"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "1rem"
            }}
          >

            {infoLocale.demo === true ? (

              <img
                src="/demo-logo.png"
                alt="Demo QrMenu"
                loading="lazy"
                style={{
                  width: "140px",
                  height: "140px",
                  objectFit: "contain",
                  borderRadius: "28px",
                  display: "block"
                }}
              />

            ) : infoLocale.logoUrl ? (

              <img
                src={infoLocale.logoUrl}
                alt="Logo locale"
                loading="lazy"
                style={{
                  width: "140px",
                  height: "140px",
                  objectFit: "contain",
                  borderRadius: "28px",
                  display: "block"
                }}
              />

            ) : (

              <div
                style={{
                  width: "140px",
                  height: "140px",
                  borderRadius: "28px",
                  background: "rgba(255,255,255,0.03)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <Logo size={72} />
              </div>

            )}

          </div>
        </div>

{/* 🎭 HERO DEMO PREMIUM */}
{infoLocale?.demo === true &&
 !infoLocale?.trialExpired && (

  <div
    style={{
      maxWidth: "1180px",
      margin: "0 auto 2rem auto",
      padding: "2rem",
      borderRadius: "34px",

      background:
        "linear-gradient(135deg,#181c27 0%,#11131a 100%)",

      border: "1px solid rgba(255,255,255,0.06)",

      boxShadow:
        "0 25px 80px rgba(0,0,0,0.45)",

      overflow: "hidden",
      position: "relative"
    }}
  >

    {/* glow */}
    <div
      style={{
        position: "absolute",
        top: "-120px",
        right: "-120px",
        width: "280px",
        height: "280px",
        borderRadius: "999px",
        background:
          "radial-gradient(circle, rgba(255,152,0,0.22), transparent 70%)",
        pointerEvents: "none"
      }}
    />

    <div
      style={{
        display: "grid",
        gridTemplateColumns:
          "repeat(auto-fit,minmax(320px,1fr))",
        gap: "2rem",
        alignItems: "center",
        position: "relative",
        zIndex: 2
      }}
    >

      {/* LEFT */}
      <div>

        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "0.5rem",
            background: "rgba(255,152,0,0.12)",
            border:
              "1px solid rgba(255,152,0,0.22)",
            color: "#ffb74d",
            padding: "0.45rem 0.8rem",
            borderRadius: "999px",
            fontSize: "0.82rem",
            fontWeight: "700",
            marginBottom: "1rem"
          }}
        >
          ✨ DEMO PREMIUM ATTIVA
        </div>

        <h1
          style={{
            color: "#fff",
            fontSize: "clamp(2rem,4vw,3.4rem)",
            lineHeight: 1.05,
            marginBottom: "1rem",
            fontWeight: "800"
          }}
        >
          Benvenuto nel tuo
          <br />
          ristorante digitale.
        </h1>

        <p
          style={{
            color: "#9ca3af",
            fontSize: "1.05rem",
            lineHeight: 1.7,
            maxWidth: "580px"
          }}
        >
          Stai provando l’esperienza completa di QrMenu:
          menu digitale, AI, cucina realtime,
          dashboard cameriere e gestione ordini.
        </p>

        <div
          style={{
            display: "flex",
            gap: "0.8rem",
            flexWrap: "wrap",
            marginTop: "1.5rem"
          }}
        >

          <div
            style={{
              background: "rgba(255,255,255,0.04)",
              border:
                "1px solid rgba(255,255,255,0.05)",
              padding: "0.9rem 1rem",
              borderRadius: "18px",
              minWidth: "130px"
            }}
          >
            <div
              style={{
                color: "#ff9800",
                fontWeight: "700",
                fontSize: "1.2rem"
              }}
            >
              {giorniResiduiDemo}
            </div>

            <div
              style={{
                color: "#777",
                fontSize: "0.82rem",
                marginTop: "0.2rem"
              }}
            >
              giorni rimasti
            </div>
          </div>

          <div
            style={{
              background: "rgba(255,255,255,0.04)",
              border:
                "1px solid rgba(255,255,255,0.05)",
              padding: "0.9rem 1rem",
              borderRadius: "18px",
              minWidth: "130px"
            }}
          >
            <div
              style={{
                color: "#10b981",
                fontWeight: "700",
                fontSize: "1.2rem"
              }}
            >
              AI attiva
            </div>

            <div
              style={{
                color: "#777",
                fontSize: "0.82rem",
                marginTop: "0.2rem"
              }}
            >
              immagini + suggerimenti
            </div>
          </div>

          <div
            style={{
              background: "rgba(255,255,255,0.04)",
              border:
                "1px solid rgba(255,255,255,0.05)",
              padding: "0.9rem 1rem",
              borderRadius: "18px",
              minWidth: "130px"
            }}
          >
            <div
              style={{
                color: "#2196f3",
                fontWeight: "700",
                fontSize: "1.2rem"
              }}
            >
              Realtime
            </div>

            <div
              style={{
                color: "#777",
                fontSize: "0.82rem",
                marginTop: "0.2rem"
              }}
            >
              cucina + ordini live
            </div>
          </div>

        </div>

      </div>

      {/* RIGHT */}
      <div
        style={{
          display: "flex",
          justifyContent: "center"
        }}
      >

        <div
          style={{
            width: "100%",
            maxWidth: "420px",

            background:
              "linear-gradient(180deg,#1f2432,#151821)",

            border:
              "1px solid rgba(255,255,255,0.06)",

            borderRadius: "28px",

            padding: "1.5rem",

            boxShadow:
              "0 20px 60px rgba(0,0,0,0.35)"
          }}
        >

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "1rem"
            }}
          >
            <div>
              <div
                style={{
                  color: "#fff",
                  fontWeight: "700"
                }}
              >
                QrMenu AI
              </div>

              <div
                style={{
                  color: "#777",
                  fontSize: "0.85rem",
                  marginTop: "0.2rem"
                }}
              >
                Assistente intelligente attivo
              </div>
            </div>

            <div
              style={{
                width: "14px",
                height: "14px",
                borderRadius: "999px",
                background: "#10b981",
                boxShadow:
                  "0 0 20px rgba(16,185,129,0.8)"
              }}
            />
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "0.8rem"
            }}
          >

            {[
              "🍷 Suggerisci vino con il piatto",
              "🤖 Traduzioni AI attive",
              "📈 Upselling intelligente attivo",
              "🍕 Menu cliente realtime"
            ].map((txt, i) => (
              <div
                key={i}
                style={{
                  background:
                    "rgba(255,255,255,0.04)",

                  border:
                    "1px solid rgba(255,255,255,0.05)",

                  borderRadius: "16px",

                  padding: "0.9rem 1rem",

                  color: "#ddd",
                  fontSize: "0.92rem"
                }}
              >
                {txt}
              </div>
            ))}

          </div>

        </div>

      </div>

    </div>

  </div>
)}

            {/* 🎭 DEMO ONBOARDING */}
{infoLocale?.demo === true &&
 !infoLocale?.trialExpired &&
 !hideDemoTutorial && (
    <div
    style={{
      maxWidth: "980px",
      margin: "0 auto 2rem auto",
      background: "linear-gradient(180deg,#171922,#12141b)",
      border: "1px solid rgba(255,255,255,0.06)",
      borderRadius: "28px",
      padding: "1.1rem",
      boxShadow: "0 20px 60px rgba(0,0,0,0.35)"
    }}
  >

    {/* HEADER */}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "1rem",
        flexWrap: "wrap",
        marginBottom: "1.2rem"
      }}
    >

      <div>
        <div
          style={{
            fontSize: "0.82rem",
            color: "#ff9800",
            fontWeight: "700",
            letterSpacing: "0.5px",
            textTransform: "uppercase",
            marginBottom: "0.3rem"
          }}
        >
          DEMO GUIDATA
        </div>

        <h2
          style={{
            margin: 0,
            fontSize: "1.6rem",
            color: "#fff",
            fontWeight: "700"
          }}
        >
          👋 Benvenuto nella tua demo QrMenu
        </h2>

        <p
          style={{
            marginTop: "0.6rem",
            color: "#9ca3af",
            lineHeight: 1.5,
            maxWidth: "650px"
          }}
        >
          Completa questi passaggi per configurare il tuo locale
          e provare tutte le funzionalità premium di QrMenu.
        </p>
      </div>

      <div
  style={{
    minWidth: "150px",
    textAlign: "right"
  }}
>

  <button
    onClick={() => {
      localStorage.setItem(tutorialKey, "true");
      setHideDemoTutorial(true);
    }}
    style={{
      background: "transparent",
      border: "none",
      color: "#888",
      cursor: "pointer",
      fontSize: "0.9rem",
      marginBottom: "0.6rem"
    }}
  >
    ✕ Chiudi
  </button>

  <div
    style={{
      color: "#fff",
      fontWeight: "700",
      fontSize: "1.4rem"
    }}
  >
    {onboardingPercent}%
  </div>

  <div
    style={{
      color: "#777",
      fontSize: "0.82rem"
    }}
  >
    Configurazione completata
  </div>

</div>

    </div>

    {/* PROGRESS BAR */}
    <div
      style={{
        width: "100%",
        height: "10px",
        borderRadius: "999px",
        background: "rgba(255,255,255,0.06)",
        overflow: "hidden",
        marginBottom: "1.8rem"
      }}
    >
      <div
        style={{
          width: `${onboardingPercent}%`,
          height: "100%",
          borderRadius: "999px",
          background:
            "linear-gradient(90deg,#ff9800,#ffb74d)"
        }}
      />
    </div>

    {/* STEPS */}
    <div
      style={{
        display: "grid",
        gridTemplateColumns:
          "repeat(auto-fit,minmax(220px,1fr))",
        gap: "1rem"
      }}
    >

      {/* STEP */}
      <div
        style={{
          background: infoLocale?.menuCreato
            ? "rgba(16,185,129,0.12)"
            : "rgba(255,255,255,0.03)",
          boxShadow: infoLocale?.menuCreato
            ? "0 10px 30px rgba(16,185,129,0.12)"
            : "none",
          border: "1px solid rgba(255,255,255,0.05)",
          borderRadius: "22px",
          padding: "1rem"
        }}
      >
        <div
          style={{
            width: "54px",
            height: "54px",
            borderRadius: "16px",
            background: "rgba(255,255,255,0.04)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "1rem"
          }}
        >
          <Icons.menu style={{ color: iconColors.warning }} />
        </div>

        <h4 style={{ color: "#fff", marginBottom: "0.5rem" }}>
          Inserisci il primo piatto
        </h4>

        <p
          style={{
            color: "#888",
            fontSize: "0.9rem",
            lineHeight: 1.5
          }}
        >
          Configura il tuo menu e prova il Menu Editor.
        </p>

        <button
          onClick={async () => {
            await setDoc(
              doc(db, "locali", mieiLocali[0]),
              { menuCreato: true },
              { merge: true }
            );
            navigate("/menueditor");
          }}
          style={{
            marginTop: "1rem",
            width: "100%",
            border: "none",
            borderRadius: "14px",
            padding: "0.8rem",
            background: infoLocale?.menuCreato
              ? "#10b981"
              : "#ff9800",
            color: "#fff",
            fontWeight: "600",
            cursor: "pointer"
          }}
        >
          {infoLocale?.menuCreato
            ? "✅ Completato"
            : "Apri Menu Editor"}
        </button>
      </div>

      {/* STEP PROVA AI */}
      <div
        style={{
          background: infoLocale?.haUsatoAI
            ? "rgba(16,185,129,0.12)"
            : "rgba(255,255,255,0.03)",
          boxShadow: infoLocale?.haUsatoAI
            ? "0 10px 30px rgba(16,185,129,0.12)"
            : "none",
          border: "1px solid rgba(255,255,255,0.05)",
          borderRadius: "22px",
          padding: "1rem"
        }}
      >
        <div
          style={{
            width: "54px",
            height: "54px",
            borderRadius: "16px",
            background: "rgba(255,255,255,0.04)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "1rem"
          }}
        >
          <Icons.ai style={{ color: iconColors.ai }} />
        </div>

        <h4 style={{ color: "#fff", marginBottom: "0.5rem" }}>
          Prova l’AI
        </h4>

        <p
          style={{
            color: "#888",
            fontSize: "0.9rem",
            lineHeight: 1.5
          }}
        >
          Genera immagini e traduzioni automatiche.
        </p>

        <button
          onClick={async () => {
            await setDoc(
              doc(db, "locali", mieiLocali[0]),
              { haUsatoAI: true },
              { merge: true }
            );

            navigate("/menueditor");
          }}
          style={{
            marginTop: "1rem",
            width: "100%",
            border: "none",
            borderRadius: "14px",
            padding: "0.8rem",
            background: infoLocale?.haUsatoAI
              ? "#10b981"
              : "#8b5cf6",
            color: "#fff",
            fontWeight: "600",
            cursor: "pointer"
          }}
        >
          {infoLocale?.haUsatoAI
            ? "✅ Completato"
            : "Prova immagini AI"}
        </button>
      </div>

      {/* STEP CONFIGURA AI */}
      <div
        style={{
          background: infoLocale?.haConfiguratoAI
            ? "rgba(16,185,129,0.12)"
            : "rgba(255,255,255,0.03)",
          boxShadow: infoLocale?.haConfiguratoAI
            ? "0 10px 30px rgba(16,185,129,0.12)"
            : "none",
          border: "1px solid rgba(255,255,255,0.05)",
          borderRadius: "22px",
          padding: "1rem"
        }}
      >
        <div
          style={{
            width: "54px",
            height: "54px",
            borderRadius: "16px",
            background: "rgba(255,255,255,0.04)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "1rem"
          }}
        >
          <Icons.ai style={{ color: iconColors.ai }} />
        </div>

        <h4 style={{ color: "#fff", marginBottom: "0.5rem" }}>
          Configura AI
        </h4>

        <p
          style={{
            color: "#888",
            fontSize: "0.9rem",
            lineHeight: 1.5
          }}
        >
          Imposta le strategie AI e prova i suggerimenti intelligenti.
        </p>

        <button
          onClick={async () => {
            await setDoc(
              doc(db, "locali", mieiLocali[0]),
              { haConfiguratoAI: true },
              { merge: true }
            );

            navigate("/ai-preferenze");
          }}
          style={{
            marginTop: "1rem",
            width: "100%",
            border: "none",
            borderRadius: "14px",
            padding: "0.8rem",
            background: infoLocale?.haConfiguratoAI
              ? "#10b981"
              : "#7c3aed",
            color: "#fff",
            fontWeight: "600",
            cursor: "pointer"
          }}
        >
          {infoLocale?.haConfiguratoAI
            ? "✅ Completato"
            : "Apri configurazione AI"}
        </button>
      </div>

      {/* STEP MENU QR */}
      <div
        style={{
          background: infoLocale?.haProvatoMenu
            ? "rgba(16,185,129,0.12)"
            : "rgba(255,255,255,0.03)",
          boxShadow: infoLocale?.haProvatoMenu
            ? "0 10px 30px rgba(16,185,129,0.12)"
            : "none",
          border: "1px solid rgba(255,255,255,0.05)",
          borderRadius: "22px",
          padding: "1rem"
        }}
      >
        <div
          style={{
            width: "54px",
            height: "54px",
            borderRadius: "16px",
            background: "rgba(255,255,255,0.04)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "1rem"
          }}
        >
          <Icons.qr style={{ color: iconColors.primary }} />
        </div>

        <h4 style={{ color: "#fff", marginBottom: "0.5rem" }}>
          Prova il menu QR
        </h4>

        <p
          style={{
            color: "#888",
            fontSize: "0.9rem",
            lineHeight: 1.5
          }}
        >
          Simula l’esperienza reale del cliente.
        </p>

        <button
          onClick={() => setShowDemoTablesPopup(true)}
          style={{
            marginTop: "1rem",
            width: "100%",
            border: "none",
            borderRadius: "14px",
            padding: "0.8rem",
            background: infoLocale?.haProvatoMenu
              ? "#10b981"
              : "#2196f3",
            color: "#fff",
            fontWeight: "600",
            cursor: "pointer"
          }}
        >
          {infoLocale?.haProvatoMenu
            ? "✅ Completato"
            : "Apri menu demo"}
        </button>
      </div>

        



      {/* STEP */}
      <div
        style={{
          background: infoLocale?.haProvatoDashboardCameriere
            ? "rgba(16,185,129,0.12)"
            : "rgba(255,255,255,0.03)",
          boxShadow: infoLocale?.haProvatoDashboardCameriere
            ? "0 10px 30px rgba(16,185,129,0.12)"
            : "none",
          border: "1px solid rgba(255,255,255,0.05)",
          borderRadius: "22px",
          padding: "1rem"
        }}
      >
        <div
          style={{
            width: "54px",
            height: "54px",
            borderRadius: "16px",
            background: "rgba(255,255,255,0.04)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "1rem"
          }}
        >
          <Icons.cameriere style={{ color: iconColors.success }} />
        </div>


        <h4 style={{ color: "#fff", marginBottom: "0.5rem" }}>
          Prova Dashboard Cameriere
        </h4>

        <p
          style={{
            color: "#888",
            fontSize: "0.9rem",
            lineHeight: 1.5
          }}
        >
          Simula la presa ordini e prova la dashboard realtime.
        </p>

        <button
          onClick={async () => {
            await setDoc(
              doc(db, "locali", mieiLocali[0]),
              { haProvatoDashboardCameriere: true },
              { merge: true }
            );
            window.location.href =
  `/dashboard-cameriere?locale=${mieiLocali[0]}&cameriere=DEMO_CAMERIERE_${mieiLocali[0]}`;
          }}
          style={{
            marginTop: "1rem",
            width: "100%",
            border: "none",
            borderRadius: "14px",
            padding: "0.8rem",
            background: infoLocale?.haProvatoDashboardCameriere
              ? "#10b981"
              : "#14b8a6",
            color: "#fff",
            fontWeight: "600",
            cursor: "pointer"
          }}
        >
          {infoLocale?.haProvatoDashboardCameriere
            ? "✅ Completato"
            : "Apri Dashboard Cameriere"}
        </button>

</div>

{/* STEP CUCINA */}
<div

  style={{
    background: infoLocale?.haProvatoDashboardCucina
      ? "rgba(16,185,129,0.12)"
      : "rgba(255,255,255,0.03)",
    boxShadow: infoLocale?.haProvatoDashboardCucina
      ? "0 10px 30px rgba(16,185,129,0.12)"
      : "none",
    border: "1px solid rgba(255,255,255,0.05)",
    borderRadius: "22px",
    padding: "1rem"
  }}
>
  <div
    style={{
      width: "54px",
      height: "54px",
      borderRadius: "16px",
      background: "rgba(255,255,255,0.04)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "1rem"
    }}
  >
    <Icons.cucina style={{ color: iconColors.primary }} />
  </div>

  <h4 style={{ color: "#fff", marginBottom: "0.5rem" }}>
    Prova Dashboard Cucina
  </h4>

  <p
    style={{
      color: "#888",
      fontSize: "0.9rem",
      lineHeight: 1.5
    }}
  >
    Visualizza gli ordini realtime nella dashboard cucina.
  </p>

  <button
    onClick={async () => {
      await setDoc(
        doc(db, "locali", mieiLocali[0]),
        { haProvatoDashboardCucina: true },
        { merge: true }
      );
      window.location.href =
  `/dashboard-cucina?locale=${mieiLocali[0]}`;
    }}
    style={{
      marginTop: "1rem",
      width: "100%",
      border: "none",
      borderRadius: "14px",
      padding: "0.8rem",
      background: infoLocale?.haProvatoDashboardCucina
        ? "#10b981"
        : "#ff5722",
      color: "#fff",
      fontWeight: "600",
      cursor: "pointer"
    }}
  >
    {infoLocale?.haProvatoDashboardCucina
      ? "✅ Completato"
      : "Apri Dashboard Cucina"}
  </button>
</div>


    </div>
  </div>
)}

        {/* 🎭 QUICK ACCESS DEMO */}
        {infoLocale?.demo === true &&
         infoLocale?.trialExpired !== true &&
         hideDemoTutorial && (

          <div
            style={{
              maxWidth: "980px",
              margin: "0 auto 1.5rem auto",
              background: "linear-gradient(180deg,#171922,#12141b)",
              border: "1px solid rgba(255,255,255,0.06)",
              borderRadius: "22px",
              padding: "1rem 1.2rem",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "1rem",
              flexWrap: "wrap"
            }}
          >

            <div>
              <div
                style={{
                  color: "#fff",
                  fontWeight: "700",
                  fontSize: "1rem"
                }}
              >
                🎭 Accesso rapido demo
              </div>

              <div
                style={{
                  color: "#888",
                  fontSize: "0.88rem",
                  marginTop: "0.3rem"
                }}
              >
                Continua a testare tutte le esperienze realtime di QrMenu.
              </div>
            </div>

            <div
              style={{
                display: "flex",
                gap: "0.8rem",
                flexWrap: "wrap"
              }}
            >

              <button
                onClick={() => setShowDemoTablesPopup(true)}
                style={{
                  border: "none",
                  borderRadius: "14px",
                  padding: "0.85rem 1.2rem",
                  background: "#2196f3",
                  color: "#fff",
                  fontWeight: "600",
                  cursor: "pointer"
                }}
              >
                🍽️ Menu Cliente
              </button>

              <button
                onClick={() => {
                  window.location.href =
  `/dashboard-cameriere?locale=${mieiLocali[0]}&cameriere=DEMO_CAMERIERE_${mieiLocali[0]}`;
                }}
                style={{
                  border: "none",
                  borderRadius: "14px",
                  padding: "0.85rem 1.2rem",
                  background: "#14b8a6",
                  color: "#fff",
                  fontWeight: "600",
                  cursor: "pointer"
                }}
              >
                🧑‍🍳 Cameriere
              </button>

              <button
                onClick={() => {
                 window.location.href =
  `/dashboard-cucina?locale=${mieiLocali[0]}`;
                }}
                style={{
                  border: "none",
                  borderRadius: "14px",
                  padding: "0.85rem 1.2rem",
                  background: "#ff5722",
                  color: "#fff",
                  fontWeight: "600",
                  cursor: "pointer"
                }}
              >
                👨‍🍳 Cucina
              </button>

            </div>

          </div>

        )}
        {/* Main Actions - 3 card grandi */}
          <div className="dashboard-main-actions">
            {!infoLocale.nascondiModificaMenu && (
              <Link to="/menueditor" className="dashboard-main-action-card">
                <div className="dashboard-main-action-icon">
                  <Icons.menu style={{ color: iconColors.primary }} />
                </div>
                <p className="dashboard-main-action-label">Menu</p>
                <p className="dashboard-main-action-desc">Configura e personalizza</p>
              </Link>
            )}

        {/* Main Actions - 3 card grandi */}

            {!infoLocale.nascondiOrdini && (
              <Link to="/ordersdashboard" className="dashboard-main-action-card">
                <div className="dashboard-main-action-icon">
                  <Icons.ordini style={{ color: iconColors.warning }} />
                </div>
                <p className="dashboard-main-action-label">Ordini</p>
                <p className="dashboard-main-action-desc">Visualizza ordini</p>
              </Link>
            )}

            {!infoLocale.nascondiCassa && (
              <Link to="/dashboard-cassa" className="dashboard-main-action-card">
                <div className="dashboard-main-action-icon">
                  <Icons.cassa style={{ color: iconColors.success }} />
                </div>
                <p className="dashboard-main-action-label">Cassa</p>
                <p className="dashboard-main-action-desc">Gestione pagamenti</p>
              </Link>
            )}
          </div>
        {itemsToShow.length === 0 ? (
          <p style={{ color: "red" }}>⚠️ Il tuo account non ha un ruolo assegnato.</p>
        ) : (
          <>
            {ruolo === "admin" && (
              <div className="stats-card responsive-stats-card">
                <h3>📈 Panoramica generale</h3>
                <ul>
                  <li>🏢 Locali totali: <strong>{stats.locali}</strong></li>
                  <li>👥 Utenti registrati: <strong>{stats.utenti}</strong></li>
                  <li>🧾 Ordini totali: <strong>{stats.ordini}</strong></li>
                  <li>💶 Incasso oggi: <strong>€{incassoOggi.toFixed(2)}</strong></li>
                </ul>
              </div>
            )}
            <div className="grid-cards responsive-action-grid">
                            {!infoLocale.nascondiCucina && (
                              <div
                                className="btn-card responsive-btn-card"
                                style={{ backgroundColor: "#FF5722" }}
                                onClick={() => setShowQrCucina(true)}
                              >
                                <span
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "0.55rem",
                                    flexWrap: "wrap",
                                    textAlign: "center"
                                  }}
                                >
                                  <Icons.cucina style={{ color: iconColors.primary }} />
                                  <span>App Cucina</span>
                                </span>
                              </div>
                            )}


 {itemsToShow.map((item, index) => (
  <Link
    key={index}
    to={item.path}
    className="btn-card responsive-btn-card"
  >
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "0.55rem",
        flexWrap: "wrap",
        textAlign: "center"
      }}
    >
      {item.icon}
      <span>{item.text}</span>
    </span>
  </Link>
))}

{!infoLocale.nascondiAsporto && (
  <div
    className="btn-card responsive-btn-card"
    onClick={() => setShowAsportoMenu(true)}
  >
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "0.55rem",
        flexWrap: "wrap",
        textAlign: "center"
      }}
    >
      <Icons.qr style={{ color: iconColors.warning }} />
      <span>Gestione Asporto</span>
    </span>
  </div>
)}

              {ruolo === "admin" && (
                <div
                  className="btn-card responsive-btn-card"
                  onClick={caricaCreditoOpenAI}
                >
                  💳 Credito OpenAI
                  <div style={{ fontSize: "0.8rem", marginTop: "4px", opacity: 0.9 }}>
                    {caricamentoCredito
                      ? "Caricamento..."
                      : creditoOpenAI === null
                      ? "Mostra credito"
                      : `€ ${creditoOpenAI.toFixed(2)}`}
                  </div>
                </div>
              )}
            </div>
            {/* ASSISTENTE AI - VERSIONE COMPATTA */}
            {!infoLocale.nascondiAI && (
              <div className="ai-assistant-compact">
              <h3 
                className="ai-compact-title"
                style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
              >
                <Icons.ai style={{ color: iconColors.ai, transform: "scale(1.2)" }} />
                Assistente AI
              </h3>
              <p className="ai-compact-subtitle">Configura le strategie di vendita e testa l'esperienza del cliente</p>
              <div className="ai-compact-buttons">
                
                <button className="ai-compact-btn" onClick={() => navigate("/ai")}> 
                  <Icons.simulate /> Simula esperienza cliente
                </button>
                <button className="ai-compact-btn" onClick={() => navigate("/ai-preferenze")}> 
                  <Icons.settings /> Regole AI
                </button>
               <button
  className="ai-compact-btn"
  onClick={() => setShowAISalaConfig(true)}
>
  <Bot size={16} />
  AI Sala
</button>


              </div>
            </div>
            )}
            {/* Pannello chiamate servizio attive - QUADRATI COMPATTI 52x52 */}
            {chiamateServizio.length > 0 && (
              <div style={{
                            backgroundColor: "#1c1c1e",
                            padding: "0.8rem",
                            borderRadius: "8px",
                            marginBottom: "1rem",
                            border: "1px solid rgba(255,152,0,0.4)"
              }}>
                <div style={{ 
                  display: "flex", 
                  alignItems: "center", 
                  gap: "0.5rem",
                  marginBottom: "0.6rem",
                  fontSize: "0.85rem",
                              color: "#ffb74d",
                  fontWeight: "600"
                }}>
                  <Icons.bell style={{ color: iconColors.warning }} /> Chiamate Servizio ({chiamateServizio.length})
                </div>
                <div style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "0.5rem"
                }}>
                  {chiamateServizio.map((chiamata) => {
                    // Supporta sia "tavolo" (nuovo) che "table" (vecchio)
                    const numeroTavolo = chiamata.tavolo || chiamata.table || '?';
                    return (
                      <div
                        key={chiamata.id}
                        style={{
                          backgroundColor: "#FFE082",
                          width: "52px",
                          height: "52px",
                          borderRadius: "8px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          border: "2px solid #FF9800",
                          transition: "transform 0.15s, box-shadow 0.15s",
                          position: "relative",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                        }}
                        onClick={() => gestisciChiamataServizio(chiamata.id)}
                        onMouseOver={(e) => {
                          e.currentTarget.style.transform = "scale(1.08)";
                          e.currentTarget.style.boxShadow = "0 4px 12px rgba(255,152,0,0.4)";
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.transform = "scale(1)";
                          e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
                        }}
                      >
                        {/* Icona campanella piccola */}
                        <div style={{ fontSize: "0.9rem", marginBottom: "2px" }}><Bell size={16} strokeWidth={1.5} /></div>
                        {/* Numero tavolo BEN LEGGIBILE */}
                        <div style={{ 
                          fontSize: "1rem", 
                          fontWeight: "bold", 
                          color: "#E65100",
                          lineHeight: "1"
                        }}>
                          T{numeroTavolo}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
            {!infoLocale.nascondiStatoTavoli && (
              <div className="tavoli-container" id="tavoli-section">
                <h3 style={{ fontSize: "1rem", fontWeight: "600", color: "#ffffff", marginBottom: "1.2rem", borderBottom: "1px solid rgba(255,255,255,0.1)", paddingBottom: "0.8rem" }}>🪑 Sala in tempo reale</h3>
                {messaggio && (
                <div className={`alert ${messaggio.startsWith("✅") ? "alert-success" : "alert-error"}`}>
                  {messaggio}
                </div>
              )}
              {tavoliVisibili.length === 0 && infoLocale?.modalitaAsporto ? (
                <div style={{
                  padding: "1.5rem",
                  background: "#1c1c1e",
                  border: "1px solid rgba(255,255,255,0.1)",
                  borderRadius: "8px",
                  color: "#ffffff"
                }}>
                  <p>
                    <strong>ℹ️ Questo locale è configurato per asporto/street food.</strong>
                  </p>
                  <p>
                    La gestione tavoli non è disponibile.
                  </p>

                </div>
              ) : (
                <>
                  {/* Tavoli Principali */}
                  {tavoliVisibili.filter(t => t.sala === "principale").length > 0 && (
                    <div style={{ marginBottom: "2rem" }}>
                      <h4 style={{ marginBottom: "0.8rem", color: "rgba(255,255,255,0.6)", fontSize: "0.9rem", fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.5px" }}>Tavoli principali</h4>
                      <div className="tavoli-grid">
                        {tavoliVisibili.filter(t => t.sala === "principale").map((tavolo) => {
                          const colorClass =
  tavolo.impegnato
    ? 'card-occupied'
    : tavolo.clientePresente
      ? 'card-pending'
      : 'card-available';
                          const haChiamataServizio = chiamateServizio.some(
                            c => (c.tavolo || c.table) === tavolo.numero && c.locale === mieiLocali[0]
                          );
                          return (
                            <div 
                              key={tavolo.id} 
                              className={`responsive-card tavolo-card-compatta ${colorClass} ${haChiamataServizio ? 'card-chiamata-servizio' : ''}`}
                              onClick={() => {
                                if (tavolo.alertAI?.length > 0) {
                                  setAlertAISelezionato(tavolo);
                                  return;
                                }

                                if (!tavolo.impegnato) {
                                  setTavoloPerNuovoOrdine(tavolo.numero);
                                  setMenuOverlayOpen(true);
                                } else {
                                  setTavoloSelezionato(tavolo);
                                }
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <div
  style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "0.35rem"
  }}
>

{/* 🚨 ALERT AI */}
{tavolo.alertAI?.length > 0 && (

  <div
    style={{
      background: "rgba(255,59,48,0.18)",

      border:
        "1px solid rgba(255,59,48,0.45)",

      color: "#fff",

      borderRadius: "999px",

      padding: "0.18rem 0.55rem",

      fontSize: "0.68rem",

      fontWeight: "700",

      display: "flex",
      alignItems: "center",
      gap: "0.3rem",

      boxShadow:
        "0 0 16px rgba(255,59,48,0.35)"
    }}
  >
    🚨 ALERT
  </div>

)}



  {/* NUMERO TAVOLO */}
  <div className="card-number">
    {tavolo.numero}
  </div>

</div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                  {/* Sale aggiuntive (A, B, C...) */}
                  {[...new Set(tavoliVisibili.filter(t => t.sala !== "principale").map(t => t.sala))].sort().map(letteraSala => (
                    <div key={letteraSala} style={{ marginBottom: "2rem" }}>
                      <h4 style={{ marginBottom: "0.8rem", color: "rgba(255,255,255,0.6)", fontSize: "0.9rem", fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.5px" }}>Sala {letteraSala}</h4>
                      <div className="tavoli-grid">
                        {tavoliVisibili.filter(t => t.sala === letteraSala).map((tavolo) => {
                          const colorClass =
  tavolo.impegnato
    ? 'card-occupied'
    : tavolo.clientePresente
      ? 'card-pending'
      : 'card-available';
                          const haChiamataServizio = chiamateServizio.some(
                            c => (c.tavolo || c.table) === tavolo.numero && c.locale === mieiLocali[0]
                          );
                          return (
                            <div 
                              key={tavolo.id} 
                              className={`responsive-card tavolo-card-compatta ${colorClass} ${haChiamataServizio ? 'card-chiamata-servizio' : ''}`}
                              onClick={() => {
                                if (tavolo.alertAI?.length > 0) {
                                  setAlertAISelezionato(tavolo);
                                  return;
                                }

                                if (!tavolo.impegnato) {
                                  setTavoloPerNuovoOrdine(tavolo.numero);
                                  setMenuOverlayOpen(true);
                                } else {
                                  setTavoloSelezionato(tavolo);
                                }
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <div
  style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "0.35rem"
  }}
>

{/* 🚨 ALERT AI */}
{tavolo.alertAI?.length > 0 && (

  <div
    style={{
      background: "rgba(255,59,48,0.18)",

      border:
        "1px solid rgba(255,59,48,0.45)",

      color: "#fff",

      borderRadius: "999px",

      padding: "0.18rem 0.55rem",

      fontSize: "0.68rem",

      fontWeight: "700",

      display: "flex",
      alignItems: "center",
      gap: "0.3rem",

      boxShadow:
        "0 0 16px rgba(255,59,48,0.35)"
    }}
  >
    🚨 ALERT
  </div>

)}


  {/* NUMERO TAVOLO */}
  <div className="card-number">
    {tavolo.numero}
  </div>

</div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ))}
                </>
              )}
              </div>
            )}
          </>
        )}
       
      </div>

      {alertAISelezionato && (
  <div
    className="modal-overlay"
    onClick={() => setAlertAISelezionato(null)}
  >
    <div
      className="app-modal"
      onClick={(e) => e.stopPropagation()}
      style={{
        maxWidth: "440px",
        width: "92%"
      }}
    >
      <h3 style={{ marginTop: 0 }}>
        🚨 Alert AI Sala
      </h3>

      <p style={{ color: "#aaa" }}>
        Tavolo {alertAISelezionato.numero}
      </p>

      <div style={{ display: "flex", flexDirection: "column", gap: "0.8rem" }}>
        {alertAISelezionato.alertAI.map((alert, index) => (
          <div
            key={index}
            style={{
              background: "rgba(255,59,48,0.12)",
              border: "1px solid rgba(255,59,48,0.35)",
              borderRadius: "14px",
              padding: "1rem",
              color: "#fff"
            }}
          >
            <strong>{alert.testo}</strong>
          </div>
        ))}
      </div>

      <button
        onClick={() => {
          const tavolo = alertAISelezionato;
          setAlertAISelezionato(null);
          apriTavoloGestore(tavolo);
        }}
        style={{
          marginTop: "0.7rem",
          width: "100%",
          padding: "0.85rem",
          borderRadius: "12px",
          border: "none",
          background: "#0a84ff",
          color: "#fff",
          cursor: "pointer",
          fontWeight: "700"
        }}
      >
        Apri tavolo
      </button>

      <button
        onClick={() => segnaAlertGestito(alertAISelezionato)}
        style={{
          marginTop: "0.7rem",
          width: "100%",
          padding: "0.85rem",
          borderRadius: "12px",
          border: "none",
          background: "rgba(52,199,89,0.18)",
          color: "#34c759",
          cursor: "pointer",
          fontWeight: "700"
        }}
      >
        Alert gestito
      </button>

      <button
        onClick={() => setAlertAISelezionato(null)}
        style={{
          marginTop: "1.2rem",
          width: "100%",
          padding: "0.85rem",
          borderRadius: "12px",
          border: "none",
          background: "#2c2c2e",
          color: "#fff",
          cursor: "pointer"
        }}
      >
        Chiudi
      </button>
    </div>
  </div>
)}

      {tavoloSelezionato && (
        <div 
          style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: "rgba(0,0,0,0.5)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1000
          }}
          onClick={() => setTavoloSelezionato(null)}
        >
                <div 
                  style={{
                    backgroundColor: "#1c1c1e",
                    borderRadius: "16px",
                    padding: "2rem",
                    maxWidth: "420px",
                    width: "92%",
                    boxShadow: "0 20px 60px rgba(0,0,0,0.6)",
                    border: "1px solid rgba(255,255,255,0.05)"
                  }}
            onClick={(e) => e.stopPropagation()}
          >
                  <h3 style={{ 
                    marginTop: 0, 
                    textAlign: "center", 
                    color: "#ffffff" 
                  }}>
                    🪑 Tavolo {tavoloSelezionato.numero} – Controllo esperienza
                  </h3>
                  <p style={{ 
                    textAlign: "center", 
                    color: "rgba(255,255,255,0.6)", 
                    marginBottom: "2rem" 
                  }}>
                    Ordini attivi: {tavoloSelezionato.ordiniAttivi} | Totale: €{tavoloSelezionato.totaleOrdini.toFixed(2)}
                  </p>


            <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
              <button
                onClick={() => {
                  navigate(`/ordersdashboard?tavolo=${tavoloSelezionato.numero}`);
                }}
                style={{
                  padding: "1rem",
                  fontSize: "1rem",
                  fontWeight: "bold",
                  backgroundColor: "#2196F3",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "0.5rem"
                }}
              >
                📝 Gestisci ordini del tavolo
              </button>
              <button
                onClick={() => {
                  navigate(`/dashboard-cassa?tavolo=${tavoloSelezionato.numero}`);
                }}
                style={{
                  padding: "1rem",
                  fontSize: "1rem",
                  fontWeight: "bold",
                  backgroundColor: "#4CAF50",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "0.5rem"
                }}
              >
                💰 Concludi esperienza e incasso
              </button>
              <button
                onClick={() => setTavoloSelezionato(null)}
                style={{
                  padding: "0.7rem",
                  fontSize: "0.9rem",
                  backgroundColor: "#2c2c2e",
                  color: "#ffffff",
                  border: "1px solid rgba(255,255,255,0.1)",
                  borderRadius: "8px",
                  cursor: "pointer"
                }}
              >
                Annulla
              </button>
            </div>
          </div>
        </div>
      )}
      {/* 🎭 POPUP DEMO */}
{showDemoPopup &&
  infoLocale?.demo === true &&
  !infoLocale?.trialExpired && (

  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.45)",
      backdropFilter: "blur(12px)",
      zIndex: 999999,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "1rem"
    }}
  >
    <div
      style={{
        width: "100%",
        maxWidth: "420px",
        background: "#16181f",
        border: "1px solid rgba(255,255,255,0.08)",
        borderRadius: "28px",
        padding: "2rem",
        textAlign: "center",
        boxShadow:
          "0 20px 80px rgba(0,0,0,0.55)"
      }}
    >

      <div
        style={{
          fontSize: "3rem",
          marginBottom: "1rem"
        }}
      >
        🎭
      </div>

      <h2
        style={{
          margin: 0,
          fontSize: "1.7rem",
          fontWeight: "700",
          color: "#fff"
        }}
      >
        Prova gratuita attiva
      </h2>

      <p
        style={{
          marginTop: "1rem",
          color: "#aaa",
          lineHeight: 1.5
        }}
      >
        Ti restano{" "}
        <strong style={{ color: "#ff9800" }}>
          {giorniResiduiDemo} giorni
        </strong>{" "}
        di prova gratuita di QrMenu.
      </p>

      <button
        onClick={() =>
          setShowDemoPopup(false)
        }
        style={{
          marginTop: "1.6rem",
          background: "#ff9800",
          color: "#fff",
          border: "none",
          borderRadius: "14px",
          padding: "0.9rem 1.4rem",
          fontWeight: "600",
          cursor: "pointer",
          fontSize: "0.95rem",
          width: "100%"
        }}
      >
        Continua
      </button>

    </div>
  </div>
)}

{/* 🎭 POPUP SCELTA TAVOLO DEMO */}
{showDemoTablesPopup && (
  <div
    onClick={() => setShowDemoTablesPopup(false)}
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.55)",
      backdropFilter: "blur(14px)",
      zIndex: 999999,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "1rem"
    }}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        width: "100%",
        maxWidth: "520px",
        background: "#16181f",
        border: "1px solid rgba(255,255,255,0.08)",
        borderRadius: "28px",
        padding: "1.5rem",
        boxShadow: "0 20px 80px rgba(0,0,0,0.55)"
      }}
    >

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.8rem",
          marginBottom: "0.8rem"
        }}
      >
        <div
          style={{
            width: "52px",
            height: "52px",
            borderRadius: "16px",
            background: "rgba(33,150,243,0.15)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Icons.qr style={{ color: iconColors.primary }} />
        </div>

        <div>
          <h3
            style={{
              margin: 0,
              color: "#fff",
              fontSize: "1.25rem"
            }}
          >
            Simula il menu cliente
          </h3>

          <p
            style={{
              margin: "0.3rem 0 0 0",
              color: "#888",
              fontSize: "0.92rem"
            }}
          >
            Scegli un tavolo da aprire.
          </p>
        </div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit,minmax(80px,1fr))",
          gap: "0.8rem",
          marginTop: "1.5rem"
        }}
      >
          {Array.isArray(tavoliVisibili) &&
        tavoliVisibili.filter(t => t.numero).map((tavolo, i) => {

          const numeroTavolo = tavolo.numero;

          
          return (
            <button
              key={numeroTavolo}
              onClick={async () => {
                const tokenDemo =
                  "demo_" +
                  Math.random().toString(36).substring(2, 10);

                await setDoc(
                  doc(
                    db,
                    "locali",
                    mieiLocali[0],
                    "tavoli",
                    String(numeroTavolo)
                  ),
                  {
  tokenAttuale: tokenDemo,
  ultimoAggiornamento: serverTimestamp()
},
                  { merge: true }
                );

                await setDoc(
                  doc(db, "locali", mieiLocali[0]),
                  {
                    haProvatoMenu: true
                  },
                  { merge: true }
                );

                window.location.href =
  `/menu/${mieiLocali[0]}/${numeroTavolo}?token=${tokenDemo}`;

                setShowDemoTablesPopup(false);
              }}
              style={{
                border: "none",
                borderRadius: "16px",
                padding: "1rem 0.5rem",
                background:
                  "rgba(255,255,255,0.04)",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                fontSize: "1rem",
                transition: "0.2s"
              }}
            >
              Tav. {numeroTavolo}
            </button>
          );

        })}
      </div>

      <button
        onClick={() =>
          setShowDemoTablesPopup(false)
        }
        style={{
          marginTop: "1.4rem",
          width: "100%",
          border: "none",
          borderRadius: "16px",
          padding: "0.9rem",
          background: "#2a2d36",
          color: "#fff",
          cursor: "pointer",
          fontWeight: "600"
        }}
      >
        Chiudi
      </button>

    </div>
  </div>
)}

{/* 🛍️ MODALE ASPORTO */}
{showAsportoMenu && (
  <div
    className="modal-overlay"
    onClick={() => setShowAsportoMenu(false)}
  >
    <div
      className="app-modal"
      onClick={(e) => e.stopPropagation()}
      style={{
        maxWidth: "420px",
        width: "92%"
      }}
    >
      <h3
        style={{
          marginTop: 0,
          marginBottom: "0.8rem"
        }}
      >
        🛍️ Asporto
      </h3>

      <p
        style={{
          color: "#999",
          lineHeight: 1.6,
          marginBottom: "1.5rem"
        }}
      >
        Gestisci le funzioni dedicate agli ordini da asporto.
      </p>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "0.8rem"
        }}
      >

        <button
          type="button"
          onClick={() => {
            setShowAsportoMenu(false);
            navigate(`/qr-asporto?locale=${mieiLocali[0]}`);
          }}
          style={{
            width: "100%",
            padding: "0.9rem",
            borderRadius: "12px",
            border: "none",
            background: "#2c2c2e",
            color: "#fff",
            cursor: "pointer",
            fontWeight: "600"
          }}
        >
          📱 QR Asporto
        </button>

        <button
          type="button"
          onClick={() => {
            setShowAsportoMenu(false);
            setShowResetAsportoModal(true);
          }}
          style={{
            width: "100%",
            padding: "0.9rem",
            borderRadius: "12px",
            border: "none",
            background: "#2c2c2e",
            color: "#fff",
            cursor: "pointer",
            fontWeight: "600"
          }}
        >
          🔄 Reset numero asporto
        </button>

        <button
          type="button"
          onClick={() => {
            setShowAsportoMenu(false);
            setShowAsportoSlotsConfig(true);
          }}
          style={{
            width: "100%",
            padding: "0.9rem",
            borderRadius: "12px",
            border: "none",
            background: "#2c2c2e",
            color: "#fff",
            cursor: "pointer",
            fontWeight: "600"
          }}
        >
          🕒 Slot Asporto
        </button>

      </div>

      <button
        type="button"
        onClick={() => setShowAsportoMenu(false)}
        style={{
          marginTop: "1.2rem",
          width: "100%",
          padding: "0.9rem",
          borderRadius: "12px",
          border: "none",
          background: "#3a3a3c",
          color: "#fff",
          cursor: "pointer"
        }}
      >
        Chiudi
      </button>
    </div>
  </div>
)}

{/* 🔄 MODALE RESET NUMERO ASPORTO */}
{showResetAsportoModal && (
  <div
    className="modal-overlay"
    onClick={() => {
      if (!resetAsportoLoading) {
        setShowResetAsportoModal(false);
      }
    }}
  >
    <div
      className="app-modal"
      onClick={(e) => e.stopPropagation()}
      style={{
        maxWidth: "420px",
        width: "92%",
        textAlign: "center"
      }}
    >
      <div
        style={{
          width: "58px",
          height: "58px",
          borderRadius: "18px",
          background: "rgba(255, 59, 48, 0.12)",
          border: "1px solid rgba(255, 59, 48, 0.25)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "0 auto 1rem auto",
          fontSize: "1.6rem"
        }}
      >
        🔄
      </div>

      <h3
        style={{
          marginTop: 0,
          marginBottom: "0.8rem",
          color: "#fff"
        }}
      >
        Reset numero asporto
      </h3>

      <p
        style={{
          color: "#aaa",
          lineHeight: 1.6,
          marginBottom: "1.5rem"
        }}
      >
        Vuoi azzerare il contatore degli ordini da asporto?
        Il prossimo ordine ripartirà dal numero 1.
      </p>

      <button
        type="button"
        onClick={resetContatoreAsporto}
        disabled={resetAsportoLoading}
        style={{
          width: "100%",
          padding: "0.9rem",
          borderRadius: "12px",
          border: "none",
          background: "#ff3b30",
          color: "#fff",
          cursor: resetAsportoLoading ? "not-allowed" : "pointer",
          fontWeight: "700",
          opacity: resetAsportoLoading ? 0.65 : 1
        }}
      >
        {resetAsportoLoading
          ? "Reset in corso..."
          : "Conferma reset"}
      </button>

      <button
        type="button"
        onClick={() => setShowResetAsportoModal(false)}
        disabled={resetAsportoLoading}
        style={{
          marginTop: "0.8rem",
          width: "100%",
          padding: "0.9rem",
          borderRadius: "12px",
          border: "none",
          background: "#2c2c2e",
          color: "#fff",
          cursor: resetAsportoLoading ? "not-allowed" : "pointer",
          opacity: resetAsportoLoading ? 0.65 : 1
        }}
      >
        Annulla
      </button>
    </div>
  </div>
)}


          {menuOverlayOpen && (
            <div
              style={{
                position: "fixed",
                top: "90px",
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0,0,0,0.6)",
                zIndex: 2000,
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "center",
                paddingTop: "2rem"
              }}
            >
              <MenuEditorOverlay
                localeTag={mieiLocali[0]}
                isNew={true}
                tavoloNumero={tavoloPerNuovoOrdine}
                onClose={() => {
                  setMenuOverlayOpen(false);
                  setTavoloPerNuovoOrdine(null);
                }}
              />
            </div>
          )}

          {/* 🤖 MODALE AI SALA */}
{showAISalaConfig && (
  <div
    className="modal-overlay"
    onClick={() => setShowAISalaConfig(false)}
  >
    <div
      className="app-modal"
      onClick={(e) => e.stopPropagation()}
      style={{
        maxWidth: "560px",
        width: "92%",
        maxHeight: "85vh",
overflowY: "auto",
      }}
    >

      <h3
        style={{
          marginTop: 0,
          marginBottom: "1.5rem"
        }}
      >
        🤖 Configura AI Sala
      </h3>

      <p
        style={{
          color: "#999",
          marginBottom: "1.5rem",
          lineHeight: 1.6
        }}
      >
        Personalizza il comportamento
        dell’assistente AI per il tuo locale.
      </p>



<div
  style={{
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    marginBottom: "1.5rem"
  }}
>

  {/* 🚨 SUPERVISORE SALA */}
  <div
    style={{
      background: "rgba(255,255,255,0.04)",
      borderRadius: "16px",
      padding: "1rem"
    }}
  >

    <div
      style={{
        color: "#fff",
        fontWeight: "700",
        marginBottom: "1rem"
      }}
    >
      🚨 Supervisore Sala
    </div>

{[
  ["tavoloInattivo", "Tavolo inattivo", "Cliente al tavolo senza aver ancora ordinato"],
  ["tavoloServitoDa", "Tavolo servito da", "Tempo trascorso dall’ultimo ordine del cliente"]
].map(([key, label, descrizione]) => (

      <div
        key={key}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "0.8rem",
          padding: "0.75rem",
          background: "rgba(255,255,255,0.03)",
          borderRadius: "12px"
        }}
      >

        <div>
          <div
            style={{
              color: "#fff",
              fontWeight: "600"
            }}
          >
            {label}
            <span
  style={{
    color: "#888",
    fontSize: "0.75rem",
    fontWeight: "400",
    marginLeft: "0.5rem"
  }}
>
  — {descrizione}
</span>
          </div>

<div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    marginTop: "0.35rem"
  }}
>

  <span
    style={{
      color: "#777",
      fontSize: "0.78rem"
    }}
  >
    Alert dopo
  </span>

  <input
    type="number"
    min="1"
    value={
  aiSalaConfig?.supervisoreSala?.[key]?.minuti ?? ""
}
    onChange={(e) => {

      salvaAISalaConfig({
        ...aiSalaConfig,

        supervisoreSala: {
          ...aiSalaConfig.supervisoreSala,

          [key]: {
            ...(aiSalaConfig?.supervisoreSala?.[key] || {}),

            minuti:
  e.target.value === ""
    ? ""
    : Number(e.target.value)
          }
        }
      });

    }}
    style={{
      width: "68px",
      background: "#2c2c2e",
      border: "1px solid rgba(255,255,255,0.08)",
      borderRadius: "10px",
      padding: "0.45rem",
      color: "#fff",
      textAlign: "center",
      fontWeight: "600"
    }}
  />

  <span
    style={{
      color: "#777",
      fontSize: "0.78rem"
    }}
  >
    min
  </span>

</div>
        </div>

        <input
          type="checkbox"
         checked={
  aiSalaConfig?.supervisoreSala?.[key]?.enabled || false
}
          onChange={(e) => {

            salvaAISalaConfig({
              ...aiSalaConfig,

              supervisoreSala: {
                ...aiSalaConfig.supervisoreSala,

                [key]: {
                  ...(aiSalaConfig?.supervisoreSala?.[key] || {}),

                  enabled: e.target.checked
                }
              }
            });

          }}
        />

      </div>

    ))}

  </div>

  

</div>


      <button
        onClick={() => setShowAISalaConfig(false)}
        style={{
          width: "100%",
          padding: "0.9rem",
          borderRadius: "12px",
          border: "none",
          background: "#2c2c2e",
          color: "#fff",
          cursor: "pointer"
        }}
      >
        Chiudi
      </button>

    </div>
  </div>
)}

{/* 🕒 MODALE SLOT ASPORTO */}
{showAsportoSlotsConfig && (
<div
  className="modal-overlay"
  onClick={() => setShowAsportoSlotsConfig(false)}
  style={{
    alignItems: "flex-start",
    overflowY: "auto",
    paddingTop: "calc(var(--navbar-height-mobile, 56px) + 16px)",
    paddingBottom: "24px",
    boxSizing: "border-box"
  }}
>
<div
  className="app-modal"
  onClick={(e) => e.stopPropagation()}
  style={{
    maxWidth: "520px",
    width: "92%",
    maxHeight:
      "calc(100dvh - var(--navbar-height-mobile, 56px) - 40px)",
    overflowY: "auto",
    boxSizing: "border-box",
    margin: "0 auto"
  }}
>
      <h3 style={{ marginTop: 0, marginBottom: "1rem" }}>
        🕒 Configura Slot Asporto
      </h3>

      <p style={{ color: "#999", lineHeight: 1.6 }}>
        Imposta gli orari disponibili per gli ordini da asporto.
      </p>

      <label style={{ display: "flex", justifyContent: "space-between", marginTop: "1rem" }}>
        <span>Attiva slot orari</span>
        <input
          type="checkbox"
          checked={asportoSlotsConfig.enabled === true}
          onChange={(e) =>
            salvaAsportoSlotsConfig({
              ...asportoSlotsConfig,
              enabled: e.target.checked
            })
          }
        />
      </label>

      {[
        ["oraInizio", "Ora inizio", "time"],
        ["oraFine", "Ora fine", "time"],
        ["intervalloMinuti", "Durata slot minuti", "number"],
        ["maxPezziPerSlot", "Massimo pezzi per slot", "number"]
      ].map(([key, label, type]) => (
        <div key={key} style={{ marginTop: "1rem" }}>
          <label style={{ color: "#aaa", fontSize: "0.85rem" }}>
            {label}
          </label>

          <input
            type={type}
            min={type === "number" ? "1" : undefined}
            value={asportoSlotsConfig[key] ?? ""}
            onChange={(e) =>
              salvaAsportoSlotsConfig({
                ...asportoSlotsConfig,
                [key]: type === "number"
  ? e.target.value === ""
    ? ""
    : Number(e.target.value)
  : e.target.value
              })
            }
            style={{
              marginTop: "0.4rem",
              width: "100%",
              background: "#2c2c2e",
              border: "1px solid rgba(255,255,255,0.08)",
              borderRadius: "12px",
              padding: "0.75rem",
              color: "#fff"
            }}
          />
        </div>
      ))}

      <div style={{ marginTop: "1.2rem" }}>
  <label
    style={{
      color: "#aaa",
      fontSize: "0.85rem",
      display: "block",
      marginBottom: "0.6rem"
    }}
  >
    Categorie che occupano gli slot
  </label>

  <div
    style={{
      display: "flex",
      flexDirection: "column",
      gap: "0.55rem"
    }}
  >
    {categorieAsportoSlot.map((cat) => {
      const selected =
        asportoSlotsConfig.categorieConteggiate?.includes(cat.nome);

      return (
        <label
          key={cat.id}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "rgba(255,255,255,0.04)",
            border: "1px solid rgba(255,255,255,0.08)",
            borderRadius: "12px",
            padding: "0.75rem",
            color: "#fff"
          }}
        >
          <span>{cat.nome}</span>

          <input
            type="checkbox"
            checked={selected || false}
            onChange={(e) => {
              const attuali =
                asportoSlotsConfig.categorieConteggiate || [];

              const nuoveCategorie = e.target.checked
                ? [...attuali, cat.nome]
                : attuali.filter((nome) => nome !== cat.nome);

              salvaAsportoSlotsConfig({
                ...asportoSlotsConfig,
                categorieConteggiate: nuoveCategorie
              });
            }}
          />
        </label>
      );
    })}
  </div>
</div>

<button
  onClick={() => setShowAsportoSlotsConfig(false)}
  style={{
    marginTop: "1.4rem",
    width: "100%",
    padding: "0.9rem",
    borderRadius: "12px",
    border: "none",
    background: "#2c2c2e",
    color: "#fff",
    cursor: "pointer"
  }}
>
  Chiudi
</button>
    </div>
  </div>
)}


      {showQrCucina && (
  <div
  className="modal-overlay"
  onClick={() => setShowQrCucina(false)}
  style={{
    alignItems: "flex-start",
    overflowY: "auto",
    paddingTop: "calc(var(--navbar-height-mobile, 56px) + 16px)",
    paddingBottom: "24px",
    boxSizing: "border-box"
  }}
>
<div
  className="app-modal"
  onClick={(e) => e.stopPropagation()}
  style={{
    textAlign: "center",
    maxWidth: "720px",
    width: "92%",
    maxHeight:
      "calc(100dvh - var(--navbar-height-mobile, 56px) - 40px)",
    overflowY: "auto",
    boxSizing: "border-box",
    margin: "0 auto"
  }}
>
      <h3 style={{ marginTop: 0, marginBottom: "1.5rem" }}>
        👨‍🍳 App Cucina
      </h3>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
          gap: "1.5rem",
          alignItems: "start"
        }}
      >
        {/* QR INSTALLAZIONE */}
        <div
          style={{
            padding: "1rem",
            borderRadius: "14px",
            background: "rgba(255,255,255,0.04)",
            border: "1px solid rgba(255,255,255,0.08)"
          }}
        >
          <h4 style={{ marginTop: 0, marginBottom: "0.8rem" }}>
            <QrCode size={18} strokeWidth={1.5} /> Installa App
          </h4>

          <QRCodeCanvas
            value="https://kitchen-qrmenu.web.app"
            size={170}
            includeMargin={true}
          />

<p style={{ marginTop: "0.9rem", fontSize: "0.88rem", color: "#aaa" }}>
  Apri questo QR dal tablet per installare la PWA cucina
</p>

<div
  style={{
    marginTop: "0.7rem",
    fontSize: "0.8rem",
    color: "#ff9800",
    wordBreak: "break-all"
  }}
>
  https://kitchen-qrmenu.web.app
</div>
        </div>

        {/* QR CONFIGURAZIONE */}
        <div
          style={{
            padding: "1rem",
            borderRadius: "14px",
            background: "rgba(255,255,255,0.04)",
            border: "1px solid rgba(255,255,255,0.08)"
          }}
        >
          <h4 style={{ marginTop: 0, marginBottom: "0.8rem" }}>
            ⚙️ 2. Configura locale
          </h4>

          <QRCodeCanvas
            value={`https://kitchen-qrmenu.web.app/bootstrap?locale=${mieiLocali[0]}`}
            size={170}
            includeMargin={true}
          />

<p style={{ marginTop: "0.9rem", fontSize: "0.88rem", color: "#aaa" }}>
  Dopo l’installazione, scansiona questo QR per collegare la cucina al locale <strong>{mieiLocali[0]}</strong>
</p>

<div
  style={{
    marginTop: "0.7rem",
    fontSize: "0.8rem",
    color: "#ff9800",
    wordBreak: "break-all"
  }}
>
  {`https://kitchen-qrmenu.web.app/bootstrap?locale=${mieiLocali[0]}`}
</div>
        </div>
      </div>

      <button
        onClick={() => setShowQrCucina(false)}
        style={{
          marginTop: "1.5rem",
          padding: "0.7rem 1.5rem",
          borderRadius: "10px",
          border: "none",
          backgroundColor: "#333",
          color: "#fff",
          cursor: "pointer"
        }}
      >
        Chiudi
      </button>
    </div>
  </div>
)}
    </>
  );
  // ...existing code...
}

export default DashboardGestore;
